import { combineReducers } from 'redux';
import userStateReducer from './userState/reducer';

const RootReducer = combineReducers({
    userState: userStateReducer,
});

// const RootReducer = (state, action) => {
//     // if(action.type === logoutState){
//     //     state = emptyState(state, action)
//     // }

//     return AppReducer(state, action);
// }

export default RootReducer;